module.exports = __webpack_public_path__ + "static/media/starship.8beeb96e.svg";